import { HeroV2Section } from "@/templates/enterprise/enterprise-landing-page/sections";

const UniformHeroCarouselV0 = () => {
    return <HeroV2Section />;
};

export default UniformHeroCarouselV0;
